export default __webpack_public_path__ + "assets/images/bingren-nv.png";